import axios from 'axios';

const BASE = '/api';

const api = axios.create({ baseURL: BASE });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('team_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  r => r.data,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('team_token');
      localStorage.removeItem('team_info');
      window.location.reload();
    }
    return Promise.reject(err.response?.data || err);
  }
);

export const teamAPI = {
  // Login with password - backend handles both team member and advisor
  login: (advisorToken, password) =>
    api.post(`/rdv/public/${advisorToken}/team/login`, { password }),

  // Get team data (requires advisor password)
  getTeam: (advisorToken, advisorPassword) =>
    api.get(`/rdv/public/${advisorToken}/team`, { params: { pw: advisorPassword } }),

  // Get appointments for logged-in team member
  getMyAppointments: (params = {}) => api.get('/rdv', { params }),

  // Get all appointments (advisor view)
  getAllAppointments: (advisorToken, advisorPassword, params = {}) =>
    api.get(`/rdv/public/${advisorToken}/team/appointments`, { params: { ...params, pw: advisorPassword } }),

  // Update appointment
  updateAppointment: (id, data) => api.put(`/rdv/${id}`, data),

  // Appointment retour (team member - uses Bearer token)
  retour: (id, data) => api.put(`/rdv/${id}/retour`, data),

  // Appointment retour (advisor - uses pw in body)
  advisorRetour: (advisorToken, id, data, advisorPassword) =>
    api.put(`/rdv/public/${advisorToken}/retour/${id}`, { ...data, pw: advisorPassword }),

  // Team management (advisor only)
  createMember: (advisorToken, advisorPassword, data) =>
    api.post(`/rdv/public/${advisorToken}/team/members`, { ...data, pw: advisorPassword }),
  updateMember: (advisorToken, advisorPassword, memberId, data) =>
    api.put(`/rdv/public/${advisorToken}/team/members/${memberId}`, { ...data, pw: advisorPassword }),
  deleteMember: (advisorToken, advisorPassword, memberId) =>
    api.delete(`/rdv/public/${advisorToken}/team/members/${memberId}`, { data: { pw: advisorPassword } }),
  toggleTeam: (advisorToken, advisorPassword, enabled) =>
    api.post(`/rdv/public/${advisorToken}/team/toggle`, { enabled, pw: advisorPassword }),
  updateSettings: (advisorToken, advisorPassword, data) =>
    api.put(`/rdv/public/${advisorToken}/team/settings`, { ...data, pw: advisorPassword }),

  // Queue management
  getQueue: (advisorToken, advisorPassword) =>
    api.get(`/rdv/public/${advisorToken}/team/queue`, { params: { pw: advisorPassword } }),
  assignQueue: (advisorToken, advisorPassword, queueId, memberId) =>
    api.post(`/rdv/public/${advisorToken}/team/queue/${queueId}/assign`, { member_id: memberId, pw: advisorPassword }),
  completeQueue: (advisorToken, advisorPassword, queueId) =>
    api.post(`/rdv/public/${advisorToken}/team/queue/${queueId}/complete`, { pw: advisorPassword }),
  autoAssignQueue: (advisorToken, advisorPassword) =>
    api.post(`/rdv/public/${advisorToken}/team/queue/auto-assign`, { pw: advisorPassword }),
};

export default api;